import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: "ocho-pay-client",
  storage: window.localStorage,
  modules: ["user"],
});

export default new Vuex.Store({
  state: {
    search: "",
    searchTerm: "",
    visibleSearch: true,
    user: null,
    role: "",
    business: {},
    selectedBusiness: null,
    userIsValid: true,
    titlepage: "3232",
    appFrame: false,
    navBar: false,
    phoneUser: null,
    codeArea: null,
    cards: [],
    SnackbarAlert: {
      text: "",
      timeout: 2000,
      btn_closed: false,
      icon: false,
      type: "",
    },
  },
  mutations: {
    AlertSnackbar(state, config) {
      state.SnackbarAlert = config;
      return state.SnackbarAlert;
    },
    setUser(state, target) {
      //console.log(target);
      state.user = target;
      state.role = target && target.type ? target.type : null;
    },
    setSelectedBusiness(state, target) {
      state.selectedBusiness = target;
    },
    setAppFrame(state, target) {
      state.appFrame = target;
    },
    visibleSearch(state, target) {
      state.visibleSearch = target;
    },
    setSearch(state, target) {
      state.search = target;
    },

    setCards(state, target) {
      state.cards = target;
    },
    setSearchTerm(state, target) {
      state.searchTerm = target;
    },
    codeArea(state, data) {
      state.codeArea = data;
      return state.codeArea;
    },
    Phone(state, data) {
      state.phoneUser = data;
      return state.phoneUser;
    },
    settitlepage(state, target) {
      state.titlepage = target;
    },
    setNavBar(state, target) {
      state.navBar = target;
    },
    _searchTerm(state, target) {
      state.searchTerm = target;
    },
    setUserValidity(state, target) {
      state.userIsValid = target;
      setTimeout(() => {
        state.userIsValid = true;
      }, 3000);
    },
  },
  actions: {
    Alert_: ({ commit, state }, config) => {
      commit("AlertSnackbar", config);
    },
    titlepage: ({ commit, state }, t) => {
      commit("settitlepage", t);
    },
    visibleSearch: ({ commit, state }, t) => {
      commit("visibleSearch", t);
    },
    addBusiness: ({ commit, state }, business) => {
      commit("setSelectedBusiness", business);
    },
    setUser: ({ commit, state }, user) => {
      commit("setUser", user);
    },
    _codeArea: ({ commit, state }, data) => {
      commit("codeArea", data);
    },
    setPhone: ({ commit, state }, data) => {
      commit("Phone", data);
    },
    setCards: ({ commit, state }, cards) => {
      commit("setCards", cards);
    },

    _searchTerm: ({ commit, state }, dat) => {
      commit("_searchTerm", dat);
    },
    setUserValidity_: ({ commit, state }, i) => {
      commit("setUserValidity", i);
    },
  },
  getters: {
    Alert_: (state) => {
      return state.SnackbarAlert;
    },
    title: (state) => {
      return state.titlepage;
    },

    userIsValid: (state) => state.userIsValid,
    userType: (state) => state.user.type,
  },
  modules: {},
  plugins: [vuexPersist.plugin],
});
